//
//
// import React, { useEffect, useState } from 'react';
// import { Stack, Box, Typography, Button } from '@mui/material';
// import { useTheme } from '@mui/material/styles';
// import useResponsive from '../../hooks/useResponsive';
// import Header from '../../layout/dashboard/header';

// import MedicContent from '../../components/medic/MedicContents';
// import { useMutation } from '@tanstack/react-query';
// import { apiGetGeneralMedicAnalytics, apiGetMedics } from '../../api/medic';
// import { useNotificationService } from '../../components/notification';
// import { useAuth } from '../../hooks/useAuth';
// import {
//   PaginationDetails,
//   PaginationDetailsDummyData,
// } from '../../interface/api_request';

// const Medic: React.FC = () => {
//   const theme = useTheme();
//   const isMedium = useResponsive('down', 'md', 'xl');
//   const isSmall = useResponsive('down', 'sm', 'xl');
//   const { showNotification } = useNotificationService();
//   const { token } = useAuth();
//   const [stats, setStats] = useState({
//     totalMedics: 0,
//     vettedMedics: 0,
//     unvettedMedics: 0,
//   });
//   const [medic_list, setMedic_list] = useState<any>([]);
//   const [filter_data, setFilter_data] = useState('');
//   // set up pagination state
//   const [pagination_state, setPagination_state] = useState<PaginationDetails>(
//     PaginationDetailsDummyData
//   );
//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         // First call stats
//         await statsRequest.mutateAsync();
//         // Then call jobs
//         await mutation.mutateAsync();
//       } catch (error) {
//         console.error('Error in sequential calls:', error);
//       }
//     };
//     fetchData();
//   }, [pagination_state.page, filter_data]);

//   const mutation = useMutation({
//     mutationFn: () =>
//       apiGetMedics(token, `${pagination_state?.page}`, filter_data),
//     onSuccess: (data) => {
//       if (data?.status === 'error') {
//         if ('msg' in data) {
//           showNotification(data?.msg ?? '', 'error');
//           return;
//         }
//         return;
//       }
//       if ('data' in data) {
//         if (!!data?.data?.meta) {
//           setPagination_state({
//             hasNextPage: data?.data?.meta?.hasNextPage,
//             hasPrevPage: data?.data?.meta?.hasPrevPage,
//             nextPage: data?.data?.meta?.nextPage,
//             page: data?.data?.meta?.page,
//             pages: data?.data?.meta?.pages,
//             prevPage: data?.data?.meta?.prevPage,
//             reads: data?.data?.meta?.reads,
//             totalDocs: data?.data?.meta?.totalDocs,
//             unReads: data?.data?.meta?.unReads,
//           });
//         }

//         if (data?.data?.data?.length > 0) {
//           setMedic_list(data.data.data);
//         } else {
//           setMedic_list([]);
//         }
//       }
//     },
//     onError: (error) => {
//       console.error('Fetch process failed', error);
//       showNotification('Fetch process failed', 'error');
//     },
//   });
//   const statsRequest = useMutation({
//     mutationFn: () => apiGetGeneralMedicAnalytics(token),
//     onSuccess: (data) => {
//       if (data?.status === 'error') {
//         if ('msg' in data) {
//           showNotification(data?.msg ?? '', 'error');
//           return;
//         }
//         return;
//       }
//       if ('data' in data) {
//         // Handle stats data here
//         setStats(data?.data?.data[0]);
//       }
//     },
//     onError: (error) => {
//       showNotification('Stats fetch failed', 'error');
//     },
//   });

//   return (
//     <>
//       {/* Header Menu */}
//       <Header>
//         <Box
//           sx={{
//             flexGrow: 1,
//             display: 'flex',
//             flexDirection: 'row',
//             gap: '10px',
//             justifyContent: 'space-between',
//             alignItems: 'center',
//             marginRight: '1rem',
//             height: isMedium ? 60 : 75,
//           }}
//         >
//           <Stack direction={'row'} alignItems={'center'} sx={{ gap: '10px' }}>
//             <Typography
//               variant={'subtitle1'}
//               sx={{
//                 fontWeight: 500,
//                 fontFamily: 'Lexend',
//                 color: theme.palette.secondary.dark,
//               }}
//             >
//               Medic Management
//             </Typography>
//           </Stack>
//         </Box>
//       </Header>

//       <MedicContent
//         setFilterData={setFilter_data}
//         paginationState={pagination_state}
//         setPaginationState={setPagination_state}
//         stats={stats}
//         medicList={medic_list}
//         loading={mutation.isPending}
//       />
//     </>
//   );
// };

// export default Medic;

import React, { useState } from "react";
import { Stack, Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useResponsive from "../../hooks/useResponsive";
import Header from "../../layout/dashboard/header";
import MedicContent from "../../components/medic/MedicContents";
import { useQuery } from "@tanstack/react-query";
import { apiGetGeneralMedicAnalytics, apiGetMedics } from "../../api/medic";
import { useNotificationService } from "../../components/notification";
import {
  PaginationDetails,
  PaginationDetailsDummyData,
} from "../../interface/api_request";

const Medic: React.FC = () => {
  const theme = useTheme();
  const isMedium = useResponsive("down", "md", "xl");
  const { showNotification } = useNotificationService();

  const [filter_data, setFilter_data] = useState("");
  const [pagination_state, setPagination_state] = useState<PaginationDetails>(
    PaginationDetailsDummyData,
  );

  // Fetch medic stats
  const {
    data: statsData,
    isLoading: isStatsLoading,
    isError: isStatsError,
  } = useQuery({
    queryKey: ["medic-stats"],
    queryFn: () => apiGetGeneralMedicAnalytics(),
    staleTime: 5 * 60 * 1000, // 5 minutes
  });

  // Fetch medic list
  const {
    data: medicData,
    isLoading: isMedicLoading,
    isError: isMedicError,
  } = useQuery({
    queryKey: ["medics", pagination_state.page, filter_data],
    queryFn: () => apiGetMedics(`${pagination_state.page}`, filter_data),

    staleTime: 2 * 60 * 1000, // 2 minutes
  });

  // Extract medic list and pagination
  const medicList = medicData?.data?.data || [];
  const meta = medicData?.data?.meta;

  // Update pagination state when meta changes
  React.useEffect(() => {
    if (meta) {
      setPagination_state((prev) => ({
        ...prev,
        hasNextPage: meta.hasNextPage,
        hasPrevPage: meta.hasPrevPage,
        nextPage: meta.nextPage,
        page: meta.page,
        pages: meta.pages,
        prevPage: meta.prevPage,
        reads: meta.reads,
        totalDocs: meta.totalDocs,
        unReads: meta.unReads,
      }));
    }
  }, [meta]);

  return (
    <>
      {/* Header Menu */}
      <Header>
        <Box
          sx={{
            flexGrow: 1,
            display: "flex",
            flexDirection: "row",
            gap: "10px",
            justifyContent: "space-between",
            alignItems: "center",
            marginRight: "1rem",
            height: isMedium ? 60 : 75,
          }}
        >
          <Stack direction={"row"} alignItems={"center"} sx={{ gap: "10px" }}>
            <Typography
              variant={"subtitle1"}
              sx={{
                fontWeight: 500,
                fontFamily: "Lexend",
                color: theme.palette.secondary.dark,
              }}
            >
              Medic Management
            </Typography>
          </Stack>
        </Box>
      </Header>

      <MedicContent
        setFilterData={setFilter_data}
        paginationState={pagination_state}
        setPaginationState={setPagination_state}
        stats={
          statsData?.data?.data[0] || {
            totalMedics: 0,
            vettedMedics: 0,
            unvettedMedics: 0,
          }
        }
        medicList={medicList}
        loading={isMedicLoading || isStatsLoading}
      />
    </>
  );
};

export default Medic;
